
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/auglysingar",
      function () {
        return require("private-next-pages/um/thjonusta/auglysingar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/auglysingar"])
      });
    }
  